import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const commonAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'commonAPI',
    endpoints: (builder) => ({

        getCompanyRegistrationDropdowns: builder.query({
            query: () => ({
                url: `/util/student/dropdown?pageName=COMPANY_REGISTRATION`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getPlacementUtilDropdowns: builder.query({
            query: () => ({
                url: `/util/student/dropdown?pageName=PLACEMENT`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getViewApplicationDropdowns: builder.query({
            query: () => ({
                url: `/util/student/dropdown?pageName=VIEW_APPLICATION`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Skill master (grouped by parentId) — e.g. name=SKILLS for the soft skills list
        getAllSkillCategory: builder.query({
            query: (name) => ({
                url: `/ssp/student/skill-category/dropdown?name=${name}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getMenus: builder.query({
            query: () => ({
                url: `/placements/menus`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useLazyGetAllSkillCategoryQuery,
    useLazyGetCompanyRegistrationDropdownsQuery,
    useLazyGetPlacementUtilDropdownsQuery,
    useLazyGetViewApplicationDropdownsQuery,
    useGetMenusQuery
} = commonAPI;

export default commonAPI;
